import { render, staticRenderFns } from "./Downloadable.vue?vue&type=template&id=8c90275a&scoped=true&"
import script from "./Downloadable.vue?vue&type=script&lang=js&"
export * from "./Downloadable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c90275a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c90275a')) {
      api.createRecord('8c90275a', component.options)
    } else {
      api.reload('8c90275a', component.options)
    }
    module.hot.accept("./Downloadable.vue?vue&type=template&id=8c90275a&scoped=true&", function () {
      api.rerender('8c90275a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/Charts/Layouts/components/Downloadable.vue"
export default component.exports